import React from "react";

import Tooltip from "components/ui/tooltip/Tooltip";
import { useCurrentUser } from "lib/hooks/api/users/useCurrentUser";
import UIcon from "lib/icons/untitled_ui/UIcon";
import { joinToEnglishList, pluralise } from "lib/utils";

type CommentWithAuthor = {
  id: string;
  author?: {
    guid: string;
    firstName: string;
  } | null;
};

function CommentIcon({ comments }: { comments: CommentWithAuthor[] }): JSX.Element | null {
  const { data: currentUser } = useCurrentUser();

  if (!currentUser || comments.length === 0) {
    return null;
  }

  const tooltipText = () => {
    const userNames = new Set<string>();
    for (const c of comments) {
      if (!c.author) continue;
      userNames.add(c.author.guid === currentUser.guid ? "you" : c.author.firstName);
    }

    const commentCount = pluralise(comments.length, "comment");
    // Fall back to just the count when no author names are known, to avoid a dangling "by".
    if (userNames.size === 0) {
      return commentCount;
    }
    return `${commentCount} by ${joinToEnglishList(Array.from(userNames))}`;
  };

  return (
    <Tooltip content={tooltipText} aria-label="Notice has comments">
      <div aria-label="Notice has comments">
        <UIcon icon="messageTextCircle02" size={14} />
      </div>
    </Tooltip>
  );
}

export default CommentIcon;
